<template>
  <div class="content content--with-tabs">
    <OverlayLoader v-if="!$store.getters.contentSectionLoaded"></OverlayLoader>
    <MyHeader :breadcrumbItems="breadCrumbs"></MyHeader>

    <header class="content-header">
      <h1 v-html="section.value"></h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <!-- tabs for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
        <TabMenuList :tabs="tabContent" :search="search" @closeMenu="showList=false" :displayNumbers="displayNumber"></TabMenuList>
      </div>
    </transition>

    <div class="container main-content--tabbed">
      <div class="row" v-if="displayMenu">
        <div class="col-lg-3 d-none d-lg-block">
          <TabMenuList :tabs="tabContent" :search="search" :displayNumbers="displayNumber"></TabMenuList>
          <div class="filters" v-if="currentSelectedTab.type==='solutions' && displayFilters">
            <div class="filters-header">
              <span class="filters-title">Filters</span>
              <button class="link filters-clear" @click="clearAll()"><span>Clear all</span></button>
            </div>
            <Expander class="filters-group" v-if="categories.length">
              <template v-slot:header>
                <span class="filters-subtitle expander-title">
                  Categories
                  <span class="filters-number" v-if="filters.categories.length">{{filters.categories.length}}</span>
                </span>
              </template>
              <template v-slot:body>
                <div class="form-block-checkboxes">
                  <label v-for="category in categories" :key="category.idSettingCompany">
                    <input :id="category.idSettingCompany" type="checkbox" :value="category.idSettingCompany" v-model="filters.categories">
                    <span>{{ category.value }}</span>
                  </label>
                </div>
              </template>
            </Expander>
            <Expander class="filters-group" v-if="solutionsContentTypes.length">
              <template v-slot:header>
                <span class="filters-subtitle expander-title">
                  Content Types
                  <span class="filters-number" v-if="filters.contentTypes.length">{{filters.contentTypes.length}}</span>
                </span>
              </template>
              <template v-slot:body>
                <div class="form-block-checkboxes">
                  <label v-for="contentType in solutionsContentTypes" :key="contentType.idSettingCompany">
                    <input :id="contentType.idSettingCompany" type="checkbox" :value="contentType.idSettingCompany" v-model="filters.contentTypes">
                    <span>{{ contentType.value }}</span>
                  </label>
                </div>
              </template>
            </Expander>
            <Expander class="filters-group" v-for="filter in contentFieldFilters" :key="filter.idContentField">
              <template v-slot:header>
                <span class="filters-subtitle expander-title">
                  {{filter.name}}
                  <span class="filters-number" v-if="contentFilters[filter.idContentField].length">{{contentFilters[filter.idContentField].length}}</span>
                </span>
              </template>
              <template v-slot:body>
                <div class="form-block-checkboxes">
                  <label v-for="option in filter.options" :key="option.idContentFieldOption" @click="hardRefresh">
                    <input :id="option.idContentFieldOption" type="checkbox" :value="option.idContentFieldOption" v-model="contentFilters[filter.idContentField]">
                    <span>{{ option.value }}</span>
                  </label>
                </div>
              </template>
            </Expander>
          </div>
        </div>
        <div class="col-lg-9 article-content" v-if="currentSelectedTab && currentSelectedTab.type">
          <div class="mobile-filters d-lg-none" v-if="currentSelectedTab.type==='solutions'">
            <button class="link-icon link--filter" @click="showMenuFilter = true" v-if="categories.length">
              <i class="icon-filter"></i>
              Filter
            </button>
            <form class="form--oneliner">
              <div class="input-wrapper">
                <input type="text" v-model="search" placeholder="Search...">
              </div>
              <button @click.prevent><i class="icon-search"></i></button>
            </form>

            <transition name="fade">
              <div class="window-nav" v-if="showMenuFilter">
                <div class="window-nav-inner">
                  <div class="window-nav-top">
                    <button class="window-nav-close" @click="showMenuFilter = false"><i class="icon-chevron-b"></i></button>
                    Filter
                  </div>

                  <div class="window-nav-checkboxes" v-if="categories.length">
                    <div class="window-nav-title">
                      <span>Categories</span>
                      <button class="window-filters-clear" @click="clearAll()"><span>Clear all</span></button>
                    </div>

                    <div class="form-block-checkboxes">
                      <label v-for="category in categories" :key="category.idSettingCompany">
                        <input :id="category.idSettingCompany" type="checkbox" :value="category.idSettingCompany" v-model="filters.categories">
                        <span>{{ category.value }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="window-nav-checkboxes" v-if="solutionsContentTypes.length">
                    <div class="window-nav-title">
                      <span>Content Types</span>
                    </div>

                    <div class="form-block-checkboxes">
                      <label v-for="contentType in solutionsContentTypes" :key="contentType.idSettingCompany">
                        <input :id="contentType.idSettingCompany" type="checkbox" :value="contentType.idSettingCompany" v-model="filters.contentTypes">
                        <span>{{ contentType.value }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="window-nav-checkboxes" v-for="filter in contentFieldFilters" :key="filter.idContentField">
                    <div class="window-nav-title">
                      <span>{{filter.name}}</span>
                    </div>

                    <div class="form-block-checkboxes">
                      <label v-for="option in filter.options" :key="option.idContentFieldOption" @click="hardRefresh">
                        <input :id="option.idContentFieldOption" type="checkbox" :value="option.idContentFieldOption" v-model="contentFilters[filter.idContentField]">
                        <span>{{ option.value }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="section-header" v-if="currentSelectedTab.type === 'solutions' || currentSelectedTab.type === 'files' ">
            <form class="form--oneliner">
              <div class="input-wrapper">
                <input type="text" v-model="search" placeholder="Search...">
              </div>
              <button @click.prevent><i class="icon-search"></i></button>
            </form>
          </div>
          <HtmlContent :content="currentSelectedTab" v-if="currentSelectedTab.type==='html'"></HtmlContent>
          <SolutionGrid :boxes="filteredSolutions" v-if="currentSelectedTab.type==='solutions' && filteredSolutions.length"></SolutionGrid>
          <div v-if="currentSelectedTab.type==='solutions' && !filteredSolutions.length" class="row" style="justify-content: center;">
            <div style="display:flex; justify-content: center; flex-direction: column; text-align: center">
<!--              <img src="../assets/images/coming-soon-1.svg">-->
              <p>No matches found.</p>
              <span>Please try selecting different filters.</span>
            </div>
          </div>
          <CompanyFilesGrid :files="filteredFiles" v-if="currentSelectedTab.type==='files'"></CompanyFilesGrid>
        </div>
      </div>
      <div class="row" v-else-if="!displayMenu">
        <div class="col-lg-12 article-content">
          <HtmlContent :content="currentSelectedTab" v-if="currentSelectedTab.type==='html'"></HtmlContent>
          <SolutionGrid :boxes="filteredSolutions" v-if="currentSelectedTab.type==='solutions'"></SolutionGrid>
          <CompanyFilesGrid :boxes="filteredFiles" v-if="currentSelectedTab.type==='files'"></CompanyFilesGrid>
        </div>
      </div>
      <div v-else class="row" style="justify-content: center;">
        <div style="display:flex; justify-content: center; flex-direction: column;">
          <img src="../assets/images/coming-soon-1.svg">
          <div>Coming Soon</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../components/general/Header'
import HtmlContent from "@/components/general/HtmlContent";
import {slugify} from "@/helpers/slugify";
import SolutionGrid from "@/components/solutions/SolutionGrid";
import OverlayLoader from "@/components/general/OverlayLoader";
import settings from "@/settings";
import TabMenuList from "@/components/tabs/TabMenuList";
import tabsMixin from "@/mixins/tabsMixin";
import CompanyFilesGrid from "@/components/files/CompanyFilesGrid";
import Expander from "@/components/general/Expander";
import settingUser from "@/api/settingUser";
import moment from "moment";
export default {
  name: "CustomCompanyContent",
  mixins: [tabsMixin],
  components: {Expander, CompanyFilesGrid, TabMenuList, OverlayLoader, SolutionGrid, HtmlContent, MyHeader },
  data () {
    return {
      showList: false,
      search: '',
      filters: {
        categories: [],
        contentTypes: [],
      },
      contentFilters: {},
      showMenuFilter: false,
      displayNumbersForTabs: false,
    }
  },
  created() {
    if(this.$route.name === 'MACSverseCustomCompanyContent') {
      this.$store.dispatch('setToken','112032034eb1981b6d0e15e5cdd84f8a9849f3ac')
      this.$store.dispatch('isMACSverseUser',true)
    }
  },
  watch: {
    '$route.params.slug'() {
      this.filters.categories = []
      this.getContentSection()
    },
    filters: {
      deep: true,
      handler() {
        this.getContentSection()
      }
    },
    section: {
      deep: true,
      handler() {
        this.getContentSection()
      }
    },
    currentSelectedTab: {
      immediate: true,
      deep: true,
      handler() {
        window._paq.push(['setDocumentTitle', this.section.value +' | '+ this.currentSelectedTab.name]);
        window._paq.push(['trackPageView']);
        this.contentFieldFilters.forEach(filter => {
          if(!this.contentFilters[filter.idContentField]) {
            this.contentFilters[filter.idContentField] = this.$store.getters.userContentFieldOptions.map(elem => elem.idContentFieldOption)
          }
        })
      }
    },

  },
  computed: {
    displayNumber() {
      return this.displayNumbersForTabs || this.filters.categories.length || this.filters.contentTypes.length
    },
    displayFilters() {
      return this.categories.length || this.solutionsContentTypes.length || this.contentFieldFilters.length
    },
    contentFieldFilters() {
      if(this.currentSelectedTab.type==='solutions' && this.currentSelectedTab.contentFieldFilters && this.currentSelectedTab.contentFieldFilters.length ) {
        return this.currentSelectedTab.contentFieldFilters
      }
      return []
    },
    breadCrumbs() {
      if(this.$store.getters.isMACSverseUser) {
        return [
          {
            name: 'Home',
            path: '/MACSverse'
          },
          {
            name: this.section.value,
            path: this.$route.path
          },
        ]
      }
      return [

        {
          name: this.section.value,
          path: this.$route.path
        },
      ]
    },
    categories() {
      return this.$store.getters.customCompanyContentCategories(this.categoryIds)
    },
    solutionsContentTypes() {
      return this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.SOLUTIONS_CONTENT_TYPES).filter(item => {
        return this.solutionsContentTypesIds.includes(item.idSettingCompany)
      })
    },
    industries() {
      return this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.SOLUTIONS_CONTENT_TYPES).filter(item => {
        return this.solutionsContentTypesIds.includes(item.idSettingCompany)
      })
    },
    solutionsContentTypesIds() {
      let ids = [];
      this.wholeTabContent.forEach(item => {
        // eslint-disable-next-line no-prototype-builtins
        if(item.hasOwnProperty('subtabs')) {
          return item.subtabs.forEach(elem => {
            // eslint-disable-next-line no-prototype-builtins
            if (elem.hasOwnProperty('solutions')) {
              elem.solutions.forEach(elem => {
                ids.push(elem.idContentType)
              })
            }
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (item.hasOwnProperty('solutions')) {
          item.solutions.forEach(elem => {
            ids.push(elem.idContentType)
          })
        }
      })
      return [... new Set(ids)]
    },
    categoryIds() {
      let ids = [];
      this.wholeTabContent.forEach(item => {
        // eslint-disable-next-line no-prototype-builtins
        if(item.hasOwnProperty('subtabs')) {
          return item.subtabs.forEach(elem => {
            // eslint-disable-next-line no-prototype-builtins
            if (elem.hasOwnProperty('solutions')) {
              elem.solutions.forEach(elem => {
                ids.push(elem.idCategory)
              })
            }
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (item.hasOwnProperty('solutions')) {
          item.solutions.forEach(elem => {
            ids.push(elem.idCategory)
          })
        }
      })
      return [... new Set(ids)]
    },
    filteredSolutions() {
      let solutions = this.currentSelectedTab.solutions
      if(this.search) {
        solutions = solutions.filter(elem => {
          return elem.headline.toUpperCase().includes(this.search.toUpperCase()) || elem.lead.toUpperCase().includes(this.search.toUpperCase())
        })
      }
      if(this.filters.contentTypes.length) {
        solutions = solutions.filter(elem => {
          return this.filters.contentTypes.includes(elem.idContentType)
        })
      }
      this.contentFieldFilters.forEach(filter => {
        solutions = solutions.filter(elem => {
          if(this.contentFilters[filter.idContentField] && this.contentFilters[filter.idContentField].length) {
            return elem.contentFields[filter.idContentField] && elem.contentFields[filter.idContentField].some(id => this.contentFilters[filter.idContentField].includes(id))
          }
          return true
        })
      })
      return solutions
    },
    filteredFiles() {
      if(this.search) {
        return this.currentSelectedTab.files.filter(elem => {
          return elem.name.toUpperCase().includes(this.search.toUpperCase()) || elem.fileDescription.toUpperCase().includes(this.search.toUpperCase())
        })
      }
      return this.currentSelectedTab.files
    },
    section() {
      return this.$store.getters.sectionByCodeAndSlug(settings.MODULES.SETTING_COMPANY_CONTENT, this.$route.params.slug)
    },
    wholeTabContent() {
      return this.$store.getters.wholeContentSection
    },
    displayMenu() {
      if(!this.wholeTabContent || !this.wholeTabContent.length) {
        return false
      }
      if(this.wholeTabContent.length > 1) {
        return true
      }
      return this.wholeTabContent.some(item => {
        // eslint-disable-next-line no-prototype-builtins
        if(item.hasOwnProperty('solutions')) {
          return !!item.solutions.length;
        }
        // eslint-disable-next-line no-prototype-builtins
        if(item.hasOwnProperty('subtabs')) {
          return !!item.subtabs.length;
        }
        return false;
      })
    },
    tabContent() {
      let tabs = JSON.parse(JSON.stringify(this.$store.getters.contentSection))
      tabs = this.filterTabsContent(tabs);
      let filteredTabs =  tabs.filter(item => {
        // eslint-disable-next-line no-prototype-builtins
        if(item.hasOwnProperty('solutions')) {
          return !!item.solutions.length;
        }
        return true;
      }).map(item => {
        return { ...item,
          ...{
            slug: this.slugify(item.name)
          }
        }
      })
      return filteredTabs.length ?  filteredTabs : tabs
    },
    tabs() {
      return this.tabContent.map(item => {
        return {
          name: item.name,
          slug: slugify(item.name),
          type: item.type
        }
      })
    }
  },
  mounted() {
    this.getContentSection();
    window._paq.push(['setDocumentTitle', this.section.value]);
    window._paq.push(['trackPageView']);
    this.updateNotificationDate();
  },
  methods: {
    updateNotificationDate() {
      settingUser.createSettingUser({
        idUser: this.$store.getters.user.idUser,
        idSettingCompany: this.section.idSettingCompany,
        valueDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      }, () => {
        this.$store.dispatch('updateNotification', this.section.idSettingCompany)
        this.$store.dispatch('getUserInfo')
      })
    },
    filterTabsContent(tabs) {
      this.displayNumbersForTabs = false
      tabs.forEach(item => {
        // eslint-disable-next-line no-prototype-builtins
        if (item.hasOwnProperty('solutions')) {
          //search
          if (this.search) {
            this.displayNumbersForTabs = true
            item.solutions = item.solutions.filter(elem => {
              return elem.headline.toUpperCase().includes(this.search.toUpperCase()) || elem.lead.toUpperCase().includes(this.search.toUpperCase())
            })
          }
          //contentTypes
          if (this.filters.contentTypes.length) {
            this.displayNumbersForTabs = true
            item.solutions = item.solutions.filter(elem => {
              // eslint-disable-next-line no-prototype-builtins
              return this.filters.contentTypes.includes(elem.idContentType)
            })
          }
          Object.keys(this.contentFilters).forEach(key => {
            // eslint-disable-next-line no-prototype-builtins
            if (this.contentFilters[key].length) {
              this.displayNumbersForTabs = true
              item.solutions = item.solutions.filter(elem => {
                return elem.contentFields[key] && elem.contentFields[key].some(id => this.contentFilters[key].includes(id))
              })
            }
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (item.hasOwnProperty('files')) {
          item.files = item.files.filter(el => {
            return el.name.toUpperCase().includes(this.search.toUpperCase()) || el.fileDescription.toUpperCase().includes(this.search.toUpperCase())
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (item.hasOwnProperty('subtabs')) {
          item.subtabs = this.filterTabsContent(item.subtabs)
        }
      })
      return tabs
    },
    hardRefresh() {
      this.getContentSection()
    },
    getContentSection() {
      let query = {}
      if (this.filters.categories && this.filters.categories.length) {
        query.solutionsIdCategories = this.filters.categories.join(',')
      }
      if (this.filters.contentTypes && this.filters.contentTypes.length) {
        query.solutionsIdContentTypes = this.filters.contentTypes.join(',')
      }
      if(this.section) {
        this.$store.dispatch('getContentSection', {id: this.section.idSettingCompany, query: query},)
      }
    },
    slugify: slugify,
    clearAll() {
      this.filters = {
        categories: [],
        contentTypes: []
      }
      this.contentFieldFilters.forEach(filter => {
        this.contentFilters[filter.idContentField] = []
      })
      this.search = ''
    },
  }
}
</script>
